module.exports = __webpack_public_path__ + "img/webpeedika.394522e5.png";